<auth-template>
  <div class="login-wrap">
    <section class="left">
      <img alt="{{ 'header_logo' | translate }}" class="go-logo" src="https://staticassets.goreact.com/logo-goreact-dash-2022.svg">
      <div class="welcome-back-left">
        <img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" alt="{{ 'header_logo' | translate }}">
        <h1 translate="email-and-password_welcome-back"></h1>
      </div>
      <p class="description" translate="email-and-password_description"></p>
      <img class="left-image" src="https://staticassets.goreact.com/login.png" alt="">
    </section>

    <section class="right" #content>
      <div class="sign-in-wrapper">
        @if (currentRegionLabel) {
          <button
            type="button"
            class="region-display-btn btn-none"
            (click)="openRegionSelector()"
            [attr.aria-label]="'region-selector_current-region' | translate : { region: currentRegionLabel }">
            <span>{{ currentRegionLabel }}</span>
          </button>
        }
        <span>
          <span translate="email-and-password_no-account"></span>
          <button type="button" class="signup-link goreact-btn tertiary-btn color-red" (click)="onSignUp.emit()" data-cy="create-account" translate="email-and-password_signup"></button>
        </span>
      </div>

      <div class="welcome-back-right">
        <img src="https://staticassets.goreact.com/logo-goreact-spot-2022.svg" alt="{{ 'header_logo' | translate }}">
        <h1 translate="email-and-password_welcome-back" [attr.aria-label]="'email-and-password_welcome-back-aria-label' | translate"></h1>
      </div>
      <form [formGroup]="form" (ngSubmit)="login()" goRequiredFieldsNote>
        <mat-form-field appearance="outline">
          <mat-label translate="login-form_email-label"></mat-label>
          <input id="email" type="email" name="email" data-cy="login-email-field" matInput [readonly]="email" formControlName="username" maxlength="100" class="fullstory-ignore"/>
          @if (form.controls.username.hasError('email')) {
            <mat-error translate="sign-up-form-validation-email-invalid"></mat-error>
          }
          @if (form.controls.username.hasError('required')) {
            <mat-error translate="sign-up-form-validation-email-required"></mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" goPasswordVisibilityToggle>
          <mat-label translate="login-form_password-label"></mat-label>
          <input id="password" type="password" name="password" data-cy="login-password-field" matInput formControlName="password" class="fullstory-ignore" />
          @if (form.controls.password.invalid) {
            <mat-error translate="login-form_validation-password-invalid"></mat-error>
          }
        </mat-form-field>

        <button data-cy="forgot-password" type="button" class="tertiary-btn forgot-passwd-lnk" translate="forgot-password_title" (click)="onForgotPassword.emit()"></button>

				<span class="terms-and-privacy" [innerHTML]="
					'terms-privacy-with-links-login' | translate:{
						terms: 'https://get.goreact.com/terms',
						privacy: 'https://get.goreact.com/privacy'
					}">
        </span>

        @if (errorMessage) {
          <div role="alert" class="error-message">{{errorMessage}}</div>
        }

        <div class="login-options-wrapper">
          <button
            data-cy="login-button"
            type="submit"
            class="submit-btn primary-btn"
            [disabled]="disabledButton"
            [focusOnFirstInvalidField]="{ formGroup: form, formWrapper: content }">
            <span translate="log-in"></span>
            @if (disabledButton) {
              <i class="ficon-spinner ficon-spin"></i>
            }
          </button>

          <sso-provider-button
          (onLoginWithSso)="loginWithProvider($event)"></sso-provider-button>
        </div>
      </form>

      <div class="sign-in-wrapper-bottom">
        @if (currentRegionLabel) {
          <button
            type="button"
            class="region-display-btn btn-none"
            (click)="openRegionSelector()"
            [attr.aria-label]="'region-selector_current-region' | translate : { region: currentRegionLabel }">
            <span>{{ currentRegionLabel }}</span>
          </button>
        }
        <span>
          <span translate="email-and-password_no-account"></span>
          <a (click)="onSignUp.emit()" translate="email-and-password_signup"></a>
        </span>
      </div>
    </section>
  </div>
</auth-template>
